import React, { useState, useRef, useEffect } from "react";

const AuctionResults = ({ totalResults, onSortChange, onPropertyTypeChange }) => {
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [showPropertyDropdown, setShowPropertyDropdown] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Sort By");
  const [selectedProperty, setSelectedProperty] = useState("Property Type"); // Initially empty

  const sortRef = useRef(null);
  const propertyRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (sortRef.current && !sortRef.current.contains(event.target)) {
        setShowSortDropdown(false);
      }
      if (propertyRef.current && !propertyRef.current.contains(event.target)) {
        setShowPropertyDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  // Reset Filters
  const resetFilters = () => {
    setSelectedSort("Sort By");
    setSelectedProperty("Property Type");
    onSortChange(""); // Reset sorting in parent
    onPropertyTypeChange("all"); // Reset property type in parent
  };

  return (
    <div className="bg-blue-900 max-w-[1080px] mx-auto my-4 text-white p-4 rounded-lg flex justify-between items-center">
      <span className="text-lg font-semibold">({totalResults}) results | Bank Auction</span>

      <div className="flex space-x-4">
        {/* Sort Filter */}
        <div className="relative" ref={sortRef}>
          <button
            onClick={() => setShowSortDropdown(!showSortDropdown)}
            className="bg-gray-100 text-blue-900 font-medium px-6 py-2 rounded-lg transition-all duration-300 hover:bg-gray-200 focus:ring focus:ring-gray-300"
          >
            {selectedSort}
          </button>
          {showSortDropdown && (
            <div className="absolute top-full left-0 mt-2 bg-white text-blue-900 rounded-lg shadow-lg w-48">
              <ul className="py-2">
                {["Sort By","Price: High to Low", "Price: Low to High"].map((option, index) => (
                  <li
                    key={index}
                    className={`px-4 py-2 cursor-pointer transition-all duration-300 ${
                      selectedSort === option ? "bg-blue-100 text-blue-800 font-semibold" : "hover:bg-gray-100"
                    }`}
                    onClick={() => {
                      setSelectedSort(option);
                      onSortChange(option === "Sort By" ? "" : option === "Price: High to Low" ? "highToLow" : "lowToHigh");
                      setShowSortDropdown(false);
                    }}
                  >
                    {option}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Property Type Filter */}
        <div className="relative" ref={propertyRef}>
          <button
            onClick={() => setShowPropertyDropdown(!showPropertyDropdown)}
            className="bg-gray-100 text-blue-900 font-medium px-6 py-2 rounded-lg transition-all duration-300 hover:bg-gray-200 focus:ring focus:ring-gray-300"
          >
            {selectedProperty}
          </button>
          {showPropertyDropdown && (
            <div className="absolute top-full left-0 mt-2 bg-white text-blue-900 rounded-lg shadow-lg w-48">
              <ul className="py-2">
                {["Property Type", "Residential", "Commercial", "Agriculture", "Industrial","All Properties"].map((option, index) => (
                  <li
                    key={index}
                    className={`px-4 py-2 cursor-pointer transition-all duration-300 ${
                      selectedProperty === option ? "bg-blue-100 text-blue-800 font-semibold" : "hover:bg-gray-100"
                    }`}
                    onClick={() => {
                      setSelectedProperty(option);
                      onPropertyTypeChange(option ===  "Property Type" || option === "All Properties" ? "all" : option.toLowerCase());
                      setShowPropertyDropdown(false);
                    }}
                  >
                    {option}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

          {/* Reset Filters Button */}
          <button
          onClick={resetFilters}
          className="bg-red-500 text-white px-4 py-2 rounded-lg transition-all duration-300 hover:bg-red-600 focus:ring focus:ring-red-300"
        >
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default AuctionResults;
